import '@stimulus/polyfills'
import '../src/utils/localStorage_protection'
import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import EfRendererController from '../../components/site/inquiry/ef/preview/ef_renderer_controller'

function importAll (r) {
  r.keys().forEach(r)
}

importAll(require.context('../src/inquiry', true, /.*\.js$/))
importAll(require.context('../src/select2', true, /.*\.js$/))
importAll(require.context('../../components', true, /component\.js$/))

const application = Application.start()
application.load(definitionsFromContext(require.context('../../components', true, /component_controller\.js$/)))
// EFプレビュー用コントローラを明示的に登録
application.register('ef-renderer', EfRendererController)

const images = require.context('../../components', true, /.*\.(svg|png|jpg|gif|webp)/, 'lazy')
export { images }
